const ENV = process.env.NODE_ENV || 'development';
const config = {
    development: {
        API_URL: 'http://localhost:8181/buggy_war/',
        APP_URL: 'http://localhost:8080/',
    },
    production: {
        API_URL: 'https://api-assist.nopancho.com/buggy/',
        APP_URL: 'https://assist.nopancho.com/',
    },
};
console.log('[config.ts] loaded config:', config[ENV]);
export default config[ENV];
